import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { IconChevronRight } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "../styles/NavigationDrilldownList.styles";
import { useTracking } from "../hooks/useTracking/useTracking";
var ICON_SIZE = 16;
export var NavigationDrilldownList = function NavigationDrilldownList(_ref) {
  var _page$items;
  var disabled = _ref.disabled,
    onSelect = _ref.onSelect,
    page = _ref.page;
  var tracking = useTracking();
  return /*#__PURE__*/React.createElement(_StyledUl, {
    $_css: styles.list
  }, (_page$items = page.items) === null || _page$items === void 0 ? void 0 : _page$items.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.title,
      style: {
        '--color': item.color
      }
    }, item.url ? /*#__PURE__*/React.createElement(_StyledA, {
      href: item.url,
      onClick: function onClick(evt) {
        return tracking.onClickLink(evt, item);
      },
      tabIndex: disabled ? -1 : 0,
      $_css2: [styles.button, styles.link]
    }, item.title) : /*#__PURE__*/React.createElement(_StyledButton, {
      disabled: disabled,
      onClick: function onClick() {
        onSelect(item);
        tracking.onSelect(item);
      },
      $_css3: styles.button
    }, item.title, /*#__PURE__*/React.createElement(IconChevronRight, {
      height: ICON_SIZE,
      width: ICON_SIZE
    })));
  }));
};
var _StyledUl = _styled("ul")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledA = _styled2("a")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledButton = /*#__PURE__*/_styled3("button").withConfig({
  displayName: "NavigationDrilldownList___StyledButton",
  componentId: "sc-r02916-0"
})(["", ""], function (p) {
  return p.$_css3;
});